import React, { useEffect, useState } from "react";
import { INTERVAL_BETWEEN_VILLAGE_IMAGES } from "../../../../config/layoutConfig";
import { VILLAGES } from "../../../../constants/constants";
import AHPWelcome from "../AHPWelcome/AHPWelcome";
import Arrow from "./Arrow";
import "./AHPVillagesBanner.css";

const imageStyle = {
  // position: "fixed",
  objectFit: "cover",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  zIndex: -1,
};

function AHPVillagesBanner({ openFilter }) {
  const [villagesList, setVillagesList] = useState([]);
  const [villageIndex, setVillageIndex] = useState(0);
  const [stopChange, setStopChange] = useState(false);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setVillageIndex(villageIndex + 1 === 12 ? 0 : villageIndex + 1);
  //   }, INTERVAL_BETWEEN_VILLAGE_IMAGES);
  //   if (stopChange) clearInterval(interval);
  //   return () => clearInterval(interval);
  // }, [villageIndex]);

  useEffect(() => {
    const shuffledVillageList = [...VILLAGES];
    // shuffle villages
    // for (let i = shuffledVillageList.length - 1; i > 0; i--) {
    //   const j = Math.floor(Math.random() * (i + 1));
    //   const temp = shuffledVillageList[i];
    //   shuffledVillageList[i] = shuffledVillageList[j];
    //   shuffledVillageList[j] = temp;
    // }
    setVillagesList(shuffledVillageList);
  }, []);

  return (
    !openFilter && (
      <div className="ahp-main-filter-banner">
        <img
          src={villagesList[villageIndex]?.img}
          style={imageStyle}
          alt="Aldeias Históricas de Portugal"
        />
        <div>
          <Arrow
            direction="left"
            count={12}
            index={villageIndex}
            setIndex={setVillageIndex}
            setStopChange={setStopChange}
          />
          <Arrow
            direction="right"
            count={12}
            index={villageIndex}
            setIndex={setVillageIndex}
            setStopChange={setStopChange}
          />
          <AHPWelcome villageIndex={villageIndex} villagesList={villagesList} />
        </div>
      </div>
    )
  );
}

export default React.memo(AHPVillagesBanner);
